export default function CentreOverlay({centreOverlay}: any) {
  return (
    <div className="centre-overlay"><span>{centreOverlay}</span></div>
  )
}
